module.exports = __webpack_public_path__ + "img/hyperpay.88e4e0d5.png";